import { createAsyncThunk } from '@reduxjs/toolkit';

import { RejectedPayload } from './util';
import {
  getLtiPlatforms as apiGetLtiPlatforms,
  registerLtiPlatform as apiRegisterLtiPlatform,
  updateLtiPlatform as apiUpdateLtiPlatform,
  UpdateLtiPlatformId,
  getManageXRToken as apiGetManageXRToken,
} from '../../api/admin';
import { ManageXRTokenResponse, RegisterLtiPlatformRequest } from '../../../types/routes/admin';

export const getLtiPlatforms = createAsyncThunk('admin/getLtiPlatforms', async () => {
  return apiGetLtiPlatforms();
});

export const registerLtiPlatform = createAsyncThunk(
  'admin/registerLtiPlatform',
  async (data: RegisterLtiPlatformRequest) => {
    return apiRegisterLtiPlatform(data);
  },
);

export const updateLtiPlatform = createAsyncThunk('admin/updateLtiPlatform', async (data: UpdateLtiPlatformId) => {
  return apiUpdateLtiPlatform(data);
});

interface ManageXRTokenArgs {
  serialCode: string;
  studentId: number;
}

export const getManageXRToken = createAsyncThunk<
  ManageXRTokenResponse,
  ManageXRTokenArgs,
  { rejectValue: RejectedPayload }
>('admin/get-ManageXR-token', async ({ serialCode, studentId }: ManageXRTokenArgs, { rejectWithValue }) => {
  try {
    return await apiGetManageXRToken(serialCode, studentId);
  } catch (error) {
    return rejectWithValue(error.response ? error.response.data : error);
  }
});
